import { Checkbox, FormControlLabel, FormHelperText, Grid } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import TitleAgentV2Store from '../../../stores/documentForms/titleAgentV2/titleAgentV2Store';
import TitleCompanySearch from './titleCompanySearch';
import TitleCompanyCreateForm from './titleCompanyCreateForm';

interface TitleAgentV2Props {
  store: TitleAgentV2Store;
}

const TitleAgentV2 = observer((props: TitleAgentV2Props) => {
  const { store } = props;
  const disabled = !store.canEdit;

  return (
    <Grid container spacing={3}>
      <TitleCompanySearch store={store} disabled={disabled} />
      <TitleCompanyCreateForm store={store} disabled={disabled} />
      {store.hasBroker && (
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={store.includeBroker}
                onChange={e => store.setIncludeBroker(e.target.checked)}
                disabled={disabled || store.isIncludeBrokerLocked}
                data-testid="include-broker-checkbox"
              />
            }
            label={`Include the broker in the title email${
              store.brokerContact?.email
                ? ` (${[store.brokerContact.name, store.brokerContact.email].filter(Boolean).join(' - ')})`
                : ''
            }`}
          />
          {store.isIncludeBrokerLocked && (
            <FormHelperText>
              The title chat room was already created, so this option can no longer be changed.
            </FormHelperText>
          )}
        </Grid>
      )}
    </Grid>
  );
});

export default TitleAgentV2;
